import { Routes } from '@angular/router';

import { bienvenidaEmpleadoGuard } from './core/guards/bienvenida-empleado.guard';
import { authGuard } from './core/guards/auth.guard';
import { dashboardAdminGuard } from './core/guards/dashboard-admin.guard';
import { mantenimientoAdminGuard } from './core/guards/mantenimiento-admin.guard';
import { guestGuard } from './core/guards/guest.guard';
import { setupWizardGuard } from './core/guards/setup-wizard.guard';
import { permisoGuard } from './core/guards/permiso.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/splash/splash.component').then((m) => m.SplashComponent),
  },
  {
    path: 'setup',
    canActivate: [setupWizardGuard],
    loadComponent: () => import('./pages/setup/setup.component').then((m) => m.SetupComponent),
  },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'perfil/:token',
    loadComponent: () =>
      import('./pages/perfil-publico/perfil-publico.component').then(
        (m) => m.PerfilPublicoComponent,
      ),
  },
  {
    path: 'expediente/:token',
    loadComponent: () =>
      import('./pages/expediente-publico/expediente-publico.component').then(
        (m) => m.ExpedientePublicoComponent,
      ),
  },
  {
    path: 'firmar-documentos/:token',
    loadComponent: () =>
      import('./pages/firmar-documentos-publico/firmar-documentos-publico.component').then(
        (m) => m.FirmarDocumentosPublicoComponent,
      ),
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/app-shell.component').then((m) => m.AppShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/app-entry-redirect/app-entry-redirect.component').then(
            (m) => m.AppEntryRedirectComponent,
          ),
      },
      {
        path: 'bienvenida',
        canActivate: [bienvenidaEmpleadoGuard],
        loadComponent: () =>
          import('./pages/bienvenida/bienvenida.component').then((m) => m.BienvenidaComponent),
      },
      {
        path: 'dashboard',
        canActivate: [dashboardAdminGuard],
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'riesgo-cartera',
        redirectTo: 'reportes/riesgo-cartera',
        pathMatch: 'full',
      },
      {
        path: 'reportes',
        loadComponent: () =>
          import('./pages/reportes/reportes-hub.component').then((m) => m.ReportesHubComponent),
      },
      {
        path: 'reportes/riesgo-cartera',
        loadComponent: () =>
          import('./pages/riesgo-cartera/riesgo-cartera.component').then((m) => m.RiesgoCarteraComponent),
      },
      {
        path: 'reportes/salud-cartera',
        loadComponent: () =>
          import('./pages/reportes/reportes-salud-cartera.component').then(
            (m) => m.ReportesSaludCarteraComponent,
          ),
      },
      {
        path: 'reportes/saldo-cartera',
        loadComponent: () =>
          import('./pages/reportes/reportes-saldo-cartera.component').then(
            (m) => m.ReportesSaldoCarteraComponent,
          ),
      },
      {
        path: 'reportes/cartera-por-tasa',
        loadComponent: () =>
          import('./pages/reportes/reportes-cartera-por-tasa.component').then(
            (m) => m.ReportesCarteraPorTasaComponent,
          ),
      },
      {
        path: 'reportes/flujo-mensual',
        loadComponent: () =>
          import('./pages/reportes/reportes-flujo-mensual.component').then(
            (m) => m.ReportesFlujoMensualComponent,
          ),
      },
      {
        path: 'reportes/ganancias-creditos',
        loadComponent: () =>
          import('./pages/reportes/reportes-ganancias-creditos.component').then(
            (m) => m.ReportesGananciasCreditosComponent,
          ),
      },
      {
        path: 'reportes/colocacion-prestamos',
        loadComponent: () =>
          import('./pages/reportes/reportes-colocacion-prestamos.component').then(
            (m) => m.ReportesColocacionPrestamosComponent,
          ),
      },
      {
        path: 'reportes/cartera-linea-ejecutivo',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'REPORTES', accion: 'VER' },
            { modulo: 'COMITE', accion: 'VER' },
          ],
        },
        loadComponent: () =>
          import('./pages/reportes/cartera-linea-ejecutivo.component').then(
            (m) => m.CarteraLineaEjecutivoComponent,
          ),
      },
      {
        path: 'reportes/endeudamiento',
        loadComponent: () =>
          import('./pages/reportes/reportes-endeudamiento.component').then(
            (m) => m.ReportesEndeudamientoComponent,
          ),
      },
      {
        path: 'reportes/facturas-emitidas',
        loadComponent: () =>
          import('./pages/reportes/reportes-facturas-emitidas.component').then(
            (m) => m.ReportesFacturasEmitidasComponent,
          ),
      },
      {
        path: 'reportes/calificacion',
        loadComponent: () =>
          import('./pages/reportes/reportes-calificacion.component').then(
            (m) => m.ReportesCalificacionComponent,
          ),
      },
      {
        path: 'reportes/metas-colocacion',
        loadComponent: () =>
          import('./pages/reportes/reportes-metas-colocacion.component').then(
            (m) => m.ReportesMetasColocacionComponent,
          ),
      },
      {
        path: 'reportes/control-colocacion',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'REPORTES', accion: 'VER' },
            { modulo: 'COMITE', accion: 'VER' },
          ],
        },
        loadComponent: () =>
          import('./pages/reportes/control-colocacion.component').then(
            (m) => m.ControlColocacionComponent,
          ),
      },
      {
        path: 'reportes/colocacion-creditos',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'REPORTES', accion: 'VER' },
            { modulo: 'COMITE', accion: 'VER' },
          ],
        },
        loadComponent: () =>
          import('./pages/reportes/reportes-colocacion-creditos.component').then(
            (m) => m.ReportesColocacionCreditosComponent,
          ),
      },
      {
        path: 'reportes/cartera-refinanciable',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'REPORTES', accion: 'VER' },
            { modulo: 'COMITE', accion: 'VER' },
          ],
        },
        loadComponent: () =>
          import('./pages/reportes/cartera-refinanciable.component').then(
            (m) => m.CarteraRefinanciableComponent,
          ),
      },
      {
        path: 'reportes/calendario-pagos',
        loadComponent: () =>
          import('./pages/reportes/calendario-pagos.component').then(
            (m) => m.CalendarioPagosComponent,
          ),
      },
      {
        path: 'reportes/corte-cobros-diario',
        loadComponent: () =>
          import('./pages/reportes/corte-cobros-diario.component').then(
            (m) => m.CorteCobrosDiarioComponent,
          ),
      },
      {
        path: 'reportes/cobros-diarios',
        loadComponent: () =>
          import('./pages/reportes/reporte-cobros-diarios.component').then(
            (m) => m.ReporteCobrosDiariosComponent,
          ),
      },
      {
        path: 'clientes',
        loadComponent: () =>
          import('./pages/clientes/clientes.component').then((m) => m.ClientesComponent),
      },
      {
        path: 'clientes-contacto',
        loadComponent: () =>
          import('./pages/clientes-contacto/clientes-contacto.component').then(
            (m) => m.ClientesContactoComponent,
          ),
      },
      {
        path: 'nuevo-credito',
        loadComponent: () =>
          import('./pages/originacion/originacion.component').then((m) => m.OriginacionComponent),
      },
      {
        path: 'prestamo-efectivo',
        loadComponent: () =>
          import('./pages/prestamo-efectivo/prestamo-efectivo.component').then(
            (m) => m.PrestamoEfectivoComponent,
          ),
      },
      {
        path: 'simulador-creditos',
        loadComponent: () =>
          import('./pages/simulador-creditos/simulador-creditos.component').then(
            (m) => m.SimuladorCreditosComponent,
          ),
      },
      { path: 'originacion', redirectTo: 'nuevo-credito', pathMatch: 'full' },
      {
        path: 'creditos',
        loadComponent: () =>
          import('./pages/creditos/creditos-lista.component').then((m) => m.CreditosListaComponent),
      },
      {
        path: 'creditos/:id',
        loadComponent: () =>
          import('./pages/creditos/credito-ficha.component').then((m) => m.CreditoFichaComponent),
      },
      {
        path: 'caja',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'CAJA', accion: 'VER' },
            { modulo: 'CAJA', accion: 'GESTIONAR' },
            { modulo: 'CREDITOS', accion: 'PAGAR' },
          ],
        },
        loadComponent: () =>
          import('./pages/caja-cobro/caja-cobro.component').then((m) => m.CajaCobroComponent),
      },
      {
        path: 'caja-cobros-campo',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'CAJA', accion: 'VER' },
            { modulo: 'CAJA', accion: 'GESTIONAR' },
            { modulo: 'REPORTES', accion: 'VER' },
            { modulo: 'COMITE', accion: 'VER' },
            { modulo: 'SEGURIDAD', accion: 'GESTIONAR' },
          ],
        },
        loadComponent: () =>
          import('./pages/caja-cobro/caja-cobros-campo.component').then((m) => m.CajaCobrosCampoComponent),
      },
      {
        path: 'gastos-caja',
        loadComponent: () =>
          import('./pages/gastos-caja/gastos-caja.component').then((m) => m.GastosCajaComponent),
      },
      {
        path: 'abonos',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'CREDITOS', accion: 'VER' },
            { modulo: 'REPORTES', accion: 'VER' },
            { modulo: 'CAJA', accion: 'VER' },
          ],
        },
        loadComponent: () =>
          import('./pages/abonos/abonos.component').then((m) => m.AbonosComponent),
      },
      {
        path: 'cuotas',
        loadComponent: () => import('./pages/cuotas/cuotas.component').then((m) => m.CuotasComponent),
      },
      {
        path: 'cobranzas',
        loadComponent: () =>
          import('./pages/gestion-mora/gestion-mora.component').then((m) => m.GestionMoraComponent),
      },
      {
        path: 'cobranzas/ruta-cobros',
        loadComponent: () =>
          import('./pages/cobranzas/ruta-cobros.component').then((m) => m.RutaCobrosComponent),
      },
      {
        path: 'cobranzas/mi-cartera',
        loadComponent: () =>
          import('./pages/cobranzas/mi-cartera.component').then((m) => m.MiCarteraComponent),
      },
      { path: 'mora', redirectTo: 'cobranzas', pathMatch: 'full' },
      {
        path: 'refinanciamiento',
        loadComponent: () =>
          import('./pages/refinanciamiento/refinanciamiento.component').then(
            (m) => m.RefinanciamientoComponent,
          ),
      },
      {
        path: 'productos',
        loadComponent: () =>
          import('./pages/inventario/inventario.component').then((m) => m.InventarioComponent),
      },
      {
        path: 'garantias',
        loadComponent: () =>
          import('./pages/garantias/garantias-page.component').then((m) => m.GarantiasPageComponent),
      },
      {
        path: 'documentacion/plantillas',
        canActivate: [permisoGuard],
        data: { permisos: [{ modulo: 'LEGAL', accion: 'VER' }, { modulo: 'LEGAL', accion: 'GESTIONAR' }] },
        loadComponent: () =>
          import('./pages/documentacion/plantillas-documentos.component').then(
            (m) => m.PlantillasDocumentosComponent,
          ),
      },
      {
        path: 'documentacion/tramites',
        canActivate: [permisoGuard],
        data: { permisos: [{ modulo: 'LEGAL', accion: 'VER' }, { modulo: 'LEGAL', accion: 'GESTIONAR' }] },
        loadComponent: () =>
          import('./pages/documentacion/tramites-documentos.component').then(
            (m) => m.TramitesDocumentosComponent,
          ),
      },
      { path: 'contratos', redirectTo: 'documentacion/plantillas', pathMatch: 'full' },
      {
        path: 'facturas',
        loadComponent: () =>
          import('./pages/facturas/facturas.component').then((m) => m.FacturasComponent),
      },
      {
        path: 'parametros',
        loadComponent: () =>
          import('./pages/configuracion/configuracion.component').then((m) => m.ConfiguracionComponent),
      },
      {
        path: 'parametros/catalogos-credito',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'CONFIG', accion: 'VER' },
            { modulo: 'CONFIG', accion: 'EDITAR' },
            { modulo: 'ORGANIZACION', accion: 'VER' },
            { modulo: 'ORGANIZACION', accion: 'EDITAR' },
          ],
        },
        loadComponent: () =>
          import('./pages/configuracion/catalogos-credito.component').then(
            (m) => m.CatalogosCreditoComponent,
          ),
      },
      {
        path: 'parametros/mantenimiento',
        canActivate: [mantenimientoAdminGuard],
        loadComponent: () =>
          import('./pages/mantenimiento/mantenimiento.component').then((m) => m.MantenimientoComponent),
      },
      { path: 'mantenimiento', redirectTo: 'parametros/mantenimiento', pathMatch: 'full' },
      { path: 'configuracion', redirectTo: 'parametros', pathMatch: 'full' },
      { path: 'seguridad/usuarios', redirectTo: 'equipo', pathMatch: 'full' },
      { path: 'seguridad/roles', redirectTo: 'roles', pathMatch: 'full' },
      {
        path: 'roles',
        loadComponent: () =>
          import('./pages/rbac/roles-permisos.component').then((m) => m.RolesPermisosComponent),
      },
      {
        path: 'equipo',
        loadComponent: () =>
          import('./pages/equipo/equipo-trabajo.component').then((m) => m.EquipoTrabajoComponent),
      },
      {
        path: 'comite/carteras',
        canActivate: [permisoGuard],
        data: { permisos: [{ modulo: 'COMITE', accion: 'VER' }, { modulo: 'COMITE', accion: 'GESTIONAR' }] },
        loadComponent: () =>
          import('./pages/comite/carteras-trabajo.component').then((m) => m.CarterasTrabajoComponent),
      },
      {
        path: 'comite/carteras/:id',
        canActivate: [permisoGuard],
        data: { permisos: [{ modulo: 'COMITE', accion: 'VER' }, { modulo: 'COMITE', accion: 'GESTIONAR' }] },
        loadComponent: () =>
          import('./pages/comite/cartera-trabajo-ficha.component').then((m) => m.CarteraTrabajoFichaComponent),
      },
      {
        path: 'comite/analisis',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'COMITE', accion: 'VER' },
            { modulo: 'COMITE', accion: 'GESTIONAR' },
            { modulo: 'CREDITOS', accion: 'CREAR' },
          ],
        },
        loadComponent: () =>
          import('./pages/comite/analisis-comite-list.component').then((m) => m.AnalisisComiteListComponent),
      },
      {
        path: 'comite/analisis/nuevo',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'COMITE', accion: 'GESTIONAR' },
            { modulo: 'CREDITOS', accion: 'CREAR' },
          ],
        },
        loadComponent: () =>
          import('./pages/comite/analisis-comite-nuevo.component').then((m) => m.AnalisisComiteNuevoComponent),
      },
      {
        path: 'comite/analisis/:id',
        canActivate: [permisoGuard],
        data: {
          permisos: [
            { modulo: 'COMITE', accion: 'VER' },
            { modulo: 'COMITE', accion: 'GESTIONAR' },
            { modulo: 'CREDITOS', accion: 'CREAR' },
          ],
        },
        loadComponent: () =>
          import('./pages/comite/analisis-comite-ficha.component').then((m) => m.AnalisisComiteFichaComponent),
      },
      {
        path: 'actividad',
        loadComponent: () =>
          import('./pages/actividad/actividad.component').then((m) => m.ActividadComponent),
      },
    ],
  },
  { path: 'inicio', redirectTo: 'app', pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];
